var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyPasteSelectAddPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.832,
    y: 5.832,
    width: 11.671,
    height: 11.671,
    rx: 2,
    stroke: "#D7D8D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.832 14.169H4.164c-.92 0-1.667-.747-1.667-1.668V4.164c0-.92.747-1.667 1.667-1.667h8.337c.921 0 1.668.747 1.668 1.667v1.668",
    stroke: "#D7D8D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sLCUzY3N2ZyB3aWR0aD0nMjAnIGhlaWdodD0nMjAnIHZpZXdCb3g9JzAgMCAyMCAyMCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJyUzZSAlM2NyZWN0IHg9JzUuODMxNTQnIHk9JzUuODMxNTQnIHdpZHRoPScxMS42NzE1JyBoZWlnaHQ9JzExLjY3MTUnIHJ4PScyJyBzdHJva2U9JyUyM0Q3RDhEOScgc3Ryb2tlLXdpZHRoPScxLjUnIHN0cm9rZS1saW5lY2FwPSdyb3VuZCcgc3Ryb2tlLWxpbmVqb2luPSdyb3VuZCcvJTNlICUzY3BhdGggZD0nTTUuODMxNzkgMTQuMTY4Nkg0LjE2NDQzQzMuMjQzNTcgMTQuMTY4NiAyLjQ5NzA3IDEzLjQyMjEgMi40OTcwNyAxMi41MDEyVjQuMTY0NDNDMi40OTcwNyAzLjI0MzU3IDMuMjQzNTcgMi40OTcwNyA0LjE2NDQzIDIuNDk3MDdIMTIuNTAxMkMxMy40MjIxIDIuNDk3MDcgMTQuMTY4NiAzLjI0MzU3IDE0LjE2ODYgNC4xNjQ0M1Y1LjgzMTc5JyBzdHJva2U9JyUyM0Q3RDhEOScgc3Ryb2tlLXdpZHRoPScxLjUnIHN0cm9rZS1saW5lY2FwPSdyb3VuZCcgc3Ryb2tlLWxpbmVqb2luPSdyb3VuZCcvJTNlICUzYy9zdmclM2Ui";
export { SvgCopyPasteSelectAddPlus as ReactComponent };